<template>
  <div class="MainPageCard">
  </div>
</template>

<script>
export default {
  name: "MainNavBar",
  components: {},
  data() {
    return {};
  },
};
</script>

<style>

</style>
